import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { TechnologiesProvider as Provider } from '../../components/context/technologies-context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const QUERY = graphql`
query NodeAllTechnologiesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Technologies" } }) {
    nodes {
      data
    }
  }
}
`;

export const TechnologiesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(QUERY), 'items')}>{children}</Provider>;
};
